module.exports = __webpack_public_path__ + "static/GetStarted-5-705a082cb07ae20cf2d8ae70387933ef.jpg";